import {
  last
} from 'ramda'
import {
  useEffect,
  useState
} from 'react'

const useRect = ref => {
  const [rect, setRect] = useState(ref && ref.current
    ? ref.current.getBoundingClientRect()
    : {
      bottom: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0,
      width: 0
    }
  )

  const _set = () => {
    if (ref && ref.current) {
      setRect(ref.current.getBoundingClientRect())
    }
  }

  const set = _set.bind(this)

  useEffect(() => {
    set()
    window.addEventListener('resize', set)
    window.addEventListener('scroll', set)
    const ancestors = getAncestors(ref)
    ancestors.forEach(elem => {
      elem.addEventListener('scroll', set)
    })
    const mutationObserver = listenToMutations(set)
    return () => {
      window.removeEventListener('resize', set)
      window.removeEventListener('scroll', set)
      ancestors.forEach(elem => {
        elem.removeEventListener('scroll', set)
      })
      if (mutationObserver) {
        mutationObserver.disconnect()
      }
    }
  }, [ref])

  return rect
}

export default useRect

const listenToMutations = callback => {
  if (typeof MutationObserver !== 'undefined') {
    const mutationObserver = new MutationObserver(callback)
    const config = { attributes: true, childList: true, subtree: true }
    mutationObserver.observe(document, config)
    return mutationObserver
  }
}

const getAncestors = ref => {
  if (ref && ref.current) {
    return addAncestors([ref.current])
  } else {
    return []
  }
}

const addAncestors = elems => {
  const parentNode = last(elems).parentNode
  if (parentNode) {
    return addAncestors([...elems, parentNode])
  } else {
    return elems
  }
}
